import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { ParameterService } from '../parameter.service';
import * as parameterActions from './parameter.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { Parameter } from '../../_models/parameter';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as rootActions from '../../state/app.actions';
import * as fromRoot from '../../state/app.reducer';

@Injectable()
export class ParameterEffects {

    @Effect()
    loadParameter$ = this.actions$.pipe(
        ofType(parameterActions.ParameterActitonTypes.LoadParameters),
        mergeMap((action: parameterActions.LoadParameters) => {
                this.changingLoading(true);
                return this.parameterService.getAllParameters(action.payload).pipe(
                    map((parameters: Parameter[]) => {
                        this.changingLoading(false);
                        return new parameterActions.LoadParametersSuccess(parameters);
                    }),
                    catchError(err => of(new parameterActions.LoadParametersFail(err)))
                );
            }
        )
    );


    @Effect()
    updateParameter$ = this.actions$.pipe(
        ofType(parameterActions.ParameterActitonTypes.UpdateParameter),
        mergeMap((action: parameterActions.UpdateParameter) => {
                this.changingLoading(true);
                console.log('-->... Payload UpdateParameter =');
                console.log(action.payload);
                return this.parameterService.updateParameter(action.payload).pipe(
                    map((parameter: Parameter) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server UpdateParameter =');
                        console.log(parameter);
                        if (parameter !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/parameter', null, 'info');
                            return new parameterActions.UpdateParameterSuccess(parameter);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new parameterActions.UpdateParameterFail('ERROR UpdateParameter effect.');
                        }
                    }),
                    catchError(err => of(new parameterActions.UpdateParameterFail(err)))
                );
            }
        )
    );

    // -----------------------------

    constructor(private actions$: Actions,
                private parameterService: ParameterService,
                private storeRoot: Store<fromRoot.State>) {

    }

    changingLoading(value: boolean) {
        console.log('---->>>>.... Ejecutando changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
        console.log('---->>>>.... Ejecutando Parameter Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin }));
    }
}
